<template>
  <PlainTable :sourceList="itemArray" :useExcel="true" ref="contentTable">
    <template #header>
      <caption>
        <span class="blind">두뇌톡톡 게임유형별</span>
      </caption>
      <colgroup></colgroup>
      <thead class="table_list_head table_list_head_line">
        <tr>
          <th>게임 유형</th>
          <th>호출건수</th>
          <th>이용자수</th>
          <th>완료건수</th>
          <th>완료자수</th>
          <th>평균점수</th>
        </tr>
      </thead>
    </template>
    <template #row="{rowData}">
      <tr>
        <td>{{rowData.gameType}}</td>
        <td class="right">{{rowData.requestCount}}</td>
        <td class="right">{{isTotal(rowData) ? '-' : rowData.requestUserCount}}</td>
        <td class="right">{{rowData.completeCount}}</td>
        <td class="right">{{isTotal(rowData) ? '-' : rowData.completeUserCount}}</td>
        <td class="right">{{rowData.averageScore}}</td>
      </tr>
    </template>
  </PlainTable>
</template>

<script>
export default {
  props: {
    itemArray: Array
  },
  methods: {
    isTotal(rowData) {
      return rowData.gameType === "합계" || rowData.gameType === "전체";
    }
  }
};
</script>
